import { useReorderingContext } from '../ReorderingContext';

/**
 * Hook that provides the state needed to render a placeholder during dragging
 */
export function usePlaceholderState() {
  const {
    draggingItemSize,
    fromIndex,
    phase,
    toIndex
  } = useReorderingContext();
  return {
    fromIndex,
    isDragging: phase !== 'idle',
    size: draggingItemSize,
    toIndex
  };
}